import {shallowEqual, useSelector} from 'react-redux';
import {Product} from '../Model/Product';
import {RootState} from '../Store';

export const useCartProducts = () => {
  const productIds = useSelector<RootState, number[]>(state => state.cart.cartItems.map(({productId}) => productId), shallowEqual);
  return useSelector<RootState, Product[]>(state => state.product.filter(({id}) => productIds.includes(id)), shallowEqual);
};
